import { useOrganization } from "@/features/auth/hooks/useOrganization";

export const useOrganizationInfo = () => {
  const organization = useOrganization();

  return {
    organization,
    logo: organization?.logo,
    baseline: organization?.baseline,
    name: organization?.name,
    hasLogo: !!(organization?.logo?.url || organization?.logo?.medium_url),
    image: organization?.image,
    hasImage: !!(organization?.image?.url || organization?.image?.large_url),
  };
};
